import { IBrandWallItemProps } from "../components";
import deepClone from "../helpers/deepClone";

export const brands: IBrandWallItemProps[] = [
  {
    id: 1,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "AdidasIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Adidas",
  },
  {
    id: 2,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "NakamuraIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Nakamura",
  },
  {
    id: 3,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "NewBalanceIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "New Balance",
  },
  {
    id: 4,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "AsicsIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Asics",
  },
  {
    id: 5,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "NikeIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Nike",
  },
  {
    id: 6,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "PumaIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Puma",
  },
  {
    id: 7,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "ReebokIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Reebok",
  },
  {
    id: 8,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "SkechersIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Skechers",
  },
  {
    id: 9,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "TnfIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Tnf",
  },
  {
    id: 10,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "TafIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Taf",
  },
  {
    id: 11,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "ErreaIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Errea",
  },

  {
    id: 12,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "AtkIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Atk",
  },
  {
    id: 13,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "ConverseIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Converse",
  },
  {
    id: 14,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "EverlastIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Everlast",
  },
  {
    id: 15,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "FilaIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Fila",
  },
  {
    id: 16,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "HurleyIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Hurley",
  },
  {
    id: 17,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "JordanIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Jordan",
  },
  {
    id: 18,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "MizunoIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Mizuno",
  },
  {
    id: 19,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "SaetaIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Saeta",
  },
  {
    id: 20,
    mediaData: {
      type: "svg-icon",
      data: {
        icon: "SauconyIcon",
      },
    },
    link: {
      href: "/",
    },
    title: "Saucony",
  },
];

export const brands11: IBrandWallItemProps[] = deepClone(brands.slice(0, 11));

export const brands5: IBrandWallItemProps[] = deepClone(brands.slice(0, 5));
